import React from 'react';
import ContainerBlur from '@components/navigation/ContainerBlur';
import { Link } from 'react-router-dom';

export interface DropdownNavigationItem {
  key: string;
  label: string;
  url: string;
  featureId?: number;
  hide?: boolean;
  domId?: string;
}

export interface DropdownAccountNavigationProps {
  list: DropdownNavigationItem[];
  onClickItem: (key: string) => void;
  closeDropdown: () => void;
  name: string;
  userId: number;
}

const DropdownAccountNavigation = (props: DropdownAccountNavigationProps) => {
  function handleClick(event: React.FormEvent, key: string) {
    event.stopPropagation();
    props.onClickItem(key);
  }

  return (
    <ContainerBlur clickaway={props.closeDropdown} className={'!px-0 !py-0'}>
      <div className={'px-6 py-4 cursor-default'}>
        <p
          className={
            'text-md text-primary-navyblue-dim font-black leading-5 text-ellipsis overflow-hidden whitespace-nowrap -mx-6 px-6 max-w-[200px]'
          }
        >
          {props.name}
        </p>
        <p className={'text-sm text-primary-navyblue-dim font-medium'}>
          ID: {props.userId}
        </p>
      </div>
      <div className={'px-6 py-2 shadow-[0_3px_15px_0_#27AAE166]'}>
        {props.list
          .filter(item => !item.hide)
          .map(item => {
            if (item.label === 'GeniePod') {
              return null;
            }
            return (
              <div className={'py-2'} key={item.key}>
                <div
                  key={item.key}
                  onClick={event => handleClick(event, item.key)}
                  className={
                    'w-max font-bold ' +
                    (item.key === 'logout'
                      ? 'text-alert-error'
                      : 'text-primary-navyblue')
                  }
                  id={item.domId}
                >
                  {item.url.indexOf('http') !== -1 ? (
                    <a href={item.url} target={'_blank'} rel="noreferrer">
                      {item.label}
                    </a>
                  ) : (
                    <Link to={item.url} target={'_self'}>
                      {item.label}
                    </Link>
                  )}
                </div>
              </div>
            );
          })}
      </div>
    </ContainerBlur>
  );
};

export default DropdownAccountNavigation;
